import "../PageCommon.css";
import "./DesignSpecification.css";

const DesignSpecificationPage = () => {
  return (
    <div className="page__container">
      <div className="page__head">
      </div>
      <div className="page__body">
        <div className="page__label">
          <h2>Design Specification</h2>
        </div>
      </div>
    </div>
  );
}

export default DesignSpecificationPage;